import { findClosestSize } from "../../constants/fontSizes";
import { FONT_WEIGHT_OPTIONS_MAP } from "../../constants/document";

export const parseFontSize = value => {
  let rawFontSize = value;
  if (
    rawFontSize &&
    !rawFontSize.includes("calc") &&
    rawFontSize !== "inherit" &&
    rawFontSize !== "large" &&
    rawFontSize !== "medium" &&
    rawFontSize !== "small" &&
    !value.includes("%")
  ) {
    // If the font size is in "rem", then we have to convert it first in "px",
    // otherwise it may not give the correct size,
    // ex: when "0.6875rem"(11px) passed in "parseInt" it returns 0 and "findClosestSize"
    // will return "8px", which is not correct
    if (value.includes("rem")) {
      rawFontSize = value.split("rem")[0] * 16;
    } else if (value.includes("em")) {
      rawFontSize = value.split("em")[0] * 16;
    } else if (value.includes("pt")) {
      rawFontSize = value.split("pt")[0] * 1.328;
    } else if (value.includes("pc")) {
      rawFontSize = value.split("pc")[0] * 16;
    } else if (value.includes("in")) {
      rawFontSize = value.split("in")[0] * 96;
    } else if (!value.includes("px")) {
      // when font size is not valid
      return null;
    }

    const size = findClosestSize(Math.round(parseFloat(rawFontSize, 10)));
    if (size) {
      return size.name;
    }
  }
  //ignoring values like large, medium, % etc.
  return null;
};

export const parseFontWeight = value => {
  if (value === "bold" || value === "BOLD") {
    value = "700";
  }
  if (value === "bolder" || value === "BOLDER" || value === "800") {
    value = "900";
  }

  if (value === "lighter" || value === "LIGHTER") {
    value = "300";
  }

  const fontWeight = FONT_WEIGHT_OPTIONS_MAP[value];
  if (fontWeight) {
    return fontWeight;
  }
  return null;
};

export const parseFontStyle = style => {
  let value = style.split(":").length > 1 ? style.split(":")[1] : "";
  value = value.trim();
  if (value === "oblique" || value === "italic") {
    return "ITALIC";
  }
  return null;
};